$(document).ready(function () {
  $(".multicolumn-list").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
autoplay: true,          // Activar desplazamiento automático
      autoplaySpeed: 3500,     // Tiempo entre desplazamientos (2 segundos)
      infinite: true,          // Hacer el carrusel infinito
      speed: 500,             // Velocidad del deslizamiento (1 segundo)
      arrows: false,           // Ocultar flechas de navegación
      dots: true,             // Ocultar puntos de navegación
      pauseOnHover: false,     // No detenerse cuando el usuario pase el mouse
      cssEase: 'linear',        // Movimiento lineal continuo
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
        },
      },
    ],
  });
});
